import { createApp } from 'vue'
import ElImageViewer from 'element-plus'

function imgViewer(option) {
  var dom = document.createElement('div');
  document.getElementsByTagName('body')[0].appendChild(dom);

  let tpl = '<el-image-viewer v-if="show" @close="close" :initial-index="imgIndex" :url-list="imgList" hide-on-click-modal :z-index="9999" teleported></el-image-viewer>';

  //创建vue实例
  const app = createApp({
    data() {
      return {
        imgList: option.imgList,
        imgIndex: option.imgIndex?option.imgIndex:0,
        show: true
      }
    },
    template: tpl,
    methods: {
      close() {
        this.show = false;
        document.getElementsByTagName('body')[0].removeChild(dom);
      },
    }
  })
  app.use(ElImageViewer).mount(dom)
  return app
}
export default {
  open(option) {
    return imgViewer(option)
  }
}
